var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibilityOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_689_6080",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_689_6080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1 10.6835L14.65 9.24287C14.8 8.46458 14.575 7.73597 13.975 7.05703C13.375 6.3781 12.6 6.11315 11.65 6.26219L10.2 4.82152C10.4833 4.68905 10.7708 4.58969 11.0625 4.52345C11.3542 4.45722 11.6667 4.4241 12 4.4241C13.25 4.4241 14.3125 4.85878 15.1875 5.72815C16.0625 6.59751 16.5 7.65317 16.5 8.89512C16.5 9.22631 16.4667 9.53679 16.4 9.82658C16.3333 10.1164 16.2333 10.402 16.1 10.6835ZM19.3 13.8132L17.85 12.4223C18.4833 11.942 19.0458 11.4163 19.5375 10.845C20.0292 10.2737 20.45 9.62373 20.8 8.89512C19.9667 7.22263 18.7708 5.89374 17.2125 4.90846C15.6542 3.92318 13.9167 3.43054 12 3.43054C11.5167 3.43054 11.0417 3.46366 10.575 3.52989C10.1083 3.59613 9.65 3.69549 9.2 3.82796L7.65 2.28794C8.33333 2.00643 9.03333 1.7953 9.75 1.65455C10.4667 1.51379 11.2167 1.44342 12 1.44342C14.5167 1.44342 16.7583 2.13477 18.725 3.51747C20.6917 4.90018 22.1167 6.69273 23 8.89512C22.6167 9.87212 22.1125 10.7787 21.4875 11.615C20.8625 12.4512 20.1333 13.184 19.3 13.8132ZM19.8 19.9236L15.6 15.8004C15.0167 15.9825 14.4292 16.1191 13.8375 16.2102C13.2458 16.3013 12.6333 16.3468 12 16.3468C9.48333 16.3468 7.24167 15.6555 5.275 14.2728C3.30833 12.8901 1.88333 11.0975 1 8.89512C1.35 8.01748 1.79167 7.20193 2.325 6.44848C2.85833 5.69503 3.46667 5.02023 4.15 4.4241L1.4 1.64213L2.8 0.251144L21.2 18.5327L19.8 19.9236ZM5.55 5.81508C5.06667 6.24563 4.625 6.71757 4.225 7.23091C3.825 7.74425 3.48333 8.29898 3.2 8.89512C4.03333 10.5676 5.22917 11.8965 6.7875 12.8818C8.34583 13.8671 10.0833 14.3597 12 14.3597C12.3333 14.3597 12.6583 14.339 12.975 14.2976C13.2917 14.2562 13.6167 14.2107 13.95 14.161L13.05 13.2171C12.8667 13.2668 12.6917 13.304 12.525 13.3289C12.3583 13.3537 12.1833 13.3661 12 13.3661C10.75 13.3661 9.6875 12.9315 8.8125 12.0621C7.9375 11.1927 7.5 10.1371 7.5 8.89512C7.5 8.71297 7.5125 8.53909 7.5375 8.3735C7.5625 8.20791 7.6 8.03403 7.65 7.85188L5.55 5.81508Z",
    fill: "#9A9A9A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOff);
export default __webpack_public_path__ + "static/media/visibility-off.22f862a5258847f7f785be71616182c6.svg";
export { ForwardRef as ReactComponent };